import type { ReactNode } from 'react';

interface PillProps {
  tone: 'critical' | 'warning' | 'success';
  children: ReactNode;
}

/** Small uppercase tag pill for impact/effort-style labels — visually distinct from Polaris's own Badge tones. */
export function Pill({ tone, children }: PillProps) {
  return <span className={`gp-pill gp-pill--${tone}`}>{children}</span>;
}
